export default __webpack_public_path__ + "static/media/Lengua-y-Literatura.a8097a50.png";